"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOSTBGMon = void 0;
const mobx_1 = require("mobx");
const __1 = require("../../../../..");
const changeOp_1 = require("../../../../../changeOp");
const fields_1 = require("../../fields");
const DOBaseScriptStatement_1 = require("../DOBaseScriptStatement");
class DOSTBGMon extends DOBaseScriptStatement_1.DOBaseScriptStatement {
    constructor(data, block, uniqueId) {
        super(data, block, uniqueId);
        this.hasModalForEdit = true;
        this.fileField = new fields_1.StudioFileField('bgm', () => ({
            link: this.st.link,
        }), file => {
            (0, mobx_1.runInAction)(() => {
                var _a;
                this.st.link = (_a = file === null || file === void 0 ? void 0 : file.link) !== null && _a !== void 0 ? _a : '';
            });
        });
        (0, mobx_1.makeObservable)(this, {
            link: mobx_1.computed,
        });
    }
    get st() {
        return this.data;
    }
    get link() {
        return this.st.link;
    }
    //
    // IEditor implementations
    //
    get editorFields() {
        return [...super.editorFields, this.fileField];
    }
    changeBGM(file) {
        this.block.parentChapter
            .applyChangesOnChapter({
            opType: changeOp_1.StudioChangeOpType.ChangeFile,
            file,
            target: changeOp_1.StudioChangeOpTarget.Block,
            blockUniqueId: this.block.uniqueId,
            lineUniqueId: this.uniqueId,
        })
            .catch();
    }
    generateSheetColumnsAfterBackground() {
        const result = ['', this.link, '', '', '', '', ''];
        if (!!this.executeConditionOfStatement) {
            result.push(this.executeConditionOfStatement);
        }
        return result;
    }
    async submitEditing(opFactory) {
        return super.submitEditing(opFactory).then(r => {
            this.rootStore.studioTutorialStore.markUserStudioTutorialProgress(__1.GA4_EVENT_NAME.SET_BGM);
            return r;
        });
    }
    //
    // IStudioTranslator interface
    //
    async getMessagesToTranslate() {
        return null;
    }
}
exports.DOSTBGMon = DOSTBGMon;
